export default "__VITE_PUBLIC_ASSET__d47d96a1__"